// //
import Form from 'form-backend-validation'
import { objectToFormData } from '@/../node_modules/form-backend-validation/src/util'

/**
 * Submit the form.
 *
 * @param {string} requestType
 * @param {string} url
 */
class MyForm extends Form {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   * @param {object} options
   */
  constructor (data = {}, options = {}) {
    super(data, options)
  }

  submit (requestType, url) {
    this.__validateRequestType(requestType)
    this.errors.clear()
    this.processing = true
    this.successful = false

    return new Promise((resolve, reject) => {
      this.__http[requestType](
        url,
        this.hasFiles() ? objectToFormData(this.data()) : this.data()
      )
        .then(response => {
          this.processing = false
          this.onSuccess(response.data)

          resolve([response.data, response])
        })
        .catch(error => {
          this.processing = false
          this.onFail(error)

          reject(error)
        })
    })
  }
}

export default MyForm



// WEBPACK FOOTER //
// ./src/services/form.js